<template>
  <div
    class="
      uk-container
      uk-container-expand
      uk-padding-remove
      uk-display-block
      uk-box-shadow-small
    "
  >
    <nav  class="uk-navbar uk-background-default  uk-sticky uk-sticky-fixed uk-background-default">
      <div class="uk-navbar-left">
        <slot name="navbar-left">
          <div v-if="showMenu && !showBackButton">
            <button class="uk-navbar-toggle" uk-navbar-toggle-icon></button>
            <div
              uk-dropdown="mode: click; pos: bottom-left"
              class="uk-margin-remove-top uk-padding-small"
            >
              <ul class="uk-nav uk-dropdown-nav uk-nav-default">
                <!--<li>
                    <lang-switcher></lang-switcher>
                </li>
                <li class="uk-nav-divider uk-margin-small"></li>
                -->
              </ul>
            </div>
          </div>
          <div v-if="showBackButton && !showMenu">
            <router-link v-if="backRouteName" :to="{ name: backRouteName }">
              <span uk-icon="icon:  arrow-left; ratio: 2"></span>
            </router-link>
            <a v-else @click="$router.back()">
              <span uk-icon="icon:  arrow-left; ratio: 2"></span>
            </a>
          </div>
        </slot>
      </div>

      <div class="uk-navbar-center">
        <slot name="navbar-center" v-if="!title"></slot>
        <div v-else class="uk-navbar-item">
          <router-link to="/" custom v-slot="{ navigate }">
            <a class="uk-link-heading" @click="navigate">
              <h4 class="uk-margin-remove">
              {{ title }}
              <div class="uk-text-center uk-text-small" style="line-height: 0.5rem"><version-info :showVersion="true"></version-info></div>
            </h4>
          </a>
          </router-link>
        </div>
        <div></div>
      </div>

      <div class="uk-navbar-right uk-margin-right">
        <div class="uk-navbar-item">
          <slot name="navbar-right">
            <div v-if="showRightMenu">
              <button uk-navbar-toggle-icon class="uk-button uk-button-link">
                <!--<span
                  class="uk-icon-button"
                  uk-icon="icon: more-vertical; ratio: 1"
                ></span>-->
                <!--<a class="uk-navbar-toggle" uk-navbar-toggle-icon href="#"></a>-->
              </button>
              <div uk-dropdown="mode: click; pos: bottom-right;">
                <ul class="uk-nav uk-dropdown-nav uk-nav-default">
                  <li>
                    <lang-switcher></lang-switcher>
                  </li>
                  <li class="uk-nav-divider uk-margin-small"></li>
                  <Can I="manage" a="AppUser">
                    <li>
                      <router-link :to="{ name: 'listlicenses' }">
                        <span
                          uk-icon="list"
                          class="uk-margin-small-right uk-icon"
                        ></span>
                        <span v-text="$t('licensemanagement')"></span>
                      </router-link>
                    </li>
                  </Can>
                  <Can I="manage" a="ManagementUser">
                    <li class="uk-nav-divider uk-margin-small"></li>
                    <li>
                      <router-link :to="{ name: 'usermanagement' }">
                        <span
                          uk-icon="users"
                          class="uk-margin-small-right uk-icon"
                        ></span>
                        <span v-text="$t('usermanagement')"></span>
                      </router-link>
                    </li>
                  </Can>
                  <Can I="manage" a="Customer">
                    <li class="uk-nav-divider uk-margin-small"></li>
                    <li>
                      <router-link :to="{ name: 'customermanagement' }">
                        <span
                          uk-icon="settings"
                          class="uk-margin-small-right uk-icon"
                        ></span>
                        <span v-text="$t('customermanagement')"></span>
                      </router-link>
                    </li>
                  </Can>

                  <Can I="manage" a="RegisterTan">
                    <li class="uk-nav-divider uk-margin-small"></li>
                    <li>
                      <router-link :to="{ name: 'registertan' }">
                        <span
                          uk-icon="code"
                          class="uk-margin-small-right uk-icon"
                        ></span>
                        <span v-text="$t('registertan')"></span>
                      </router-link>
                    </li>
                  </Can>

                  <Can I="manage" a="AppPermission">
                    <li class="uk-nav-divider uk-margin-small"></li>
                    <li>
                      <router-link :to="{ name: 'permissionmanagement' }">
                        <span
                          uk-icon="unlock"
                          class="uk-margin-small-right uk-icon"
                        ></span>
                        <span v-text="$t('permissionmanagement')"></span>
                      </router-link>
                    </li>
                  </Can>

                  <Can I="manage" a="LegalText">
                    <li class="uk-nav-divider uk-margin-small"></li>
                    <li>
                      <router-link :to="{ name: 'legaltextmanagement' }">
                        <span
                          uk-icon="file-text"
                          class="uk-margin-small-right uk-icon"
                        ></span>
                        <span v-text="$t('legalTexts')"></span>
                      </router-link>
                    </li>
                  </Can>
                  <li class="uk-nav-divider uk-margin-small"></li>
                  <li class="">
                    <a @click="logout()" class="">
                      <span
                        class="uk-margin-small-right uk-icon"
                        uk-icon="sign-out"
                      ></span>
                      <span class="uk-link-text">Logout</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </nav>
  </div>
</template>

<script lang="ts">
import LangSwitcher from './LangSwitcher.vue';
import { Options as Component, Prop, Vue } from 'vue-property-decorator';
import { namespace, Action } from 'vuex-class';
import { createForUser } from '@license-manager/casl-rules';
import { Ability } from '@casl/ability';
import VersionInfo from './Versioninfo.vue';

const user = namespace('user');

@Component({
  components: { LangSwitcher, VersionInfo },
  name: 'TopMenuBar',
})
class TopMenuBar extends Vue {
  @user.Action('logout') logoutStore: () => void;

  @Prop(String)
  title: string;

  @Prop(Boolean)
  showMenu: boolean;

  @Prop(Boolean)
  showBackButton: boolean;

  @Prop(Boolean)
  showRightMenu: boolean;

  @Prop(String)
  backRouteName: string;

  @user.Getter
  CASLUser;

  public logout() {
    this.logoutStore();
    this.$ability.update(createForUser({}).rules);
    this.$router.push({ name: 'login' });
  }
}

export default TopMenuBar;
</script>

<style scoped></style>
